export default __webpack_public_path__ + "static/media/new-window.828a489a.svg";